import n from "react";
import { useTheme as m, SimpleGrid as o } from "@chakra-ui/react";
const s = ({
  children: e,
  shouldUseSpacingExtraLarge: t,
  ...i
}) => {
  const {
    element: { spacingLarge: a, spacingExtraLarge: r }
  } = m();
  return /* @__PURE__ */ n.createElement(
    o,
    {
      "data-testid": "dividing-section",
      columns: { base: 1, md: 2 },
      gap: t ? r : a,
      ...i
    },
    e
  );
};
export {
  s as DividedSection
};
